import {create} from "zustand";

import {Role} from "../types";

type RolesStoreState = {
  roles: Role[];
};

type RolesStoreActions = {
  setRoles: (roles: Role[]) => void;
};

export const useRolesStore = create<RolesStoreState & RolesStoreActions>((set) => ({
  roles: [],

  setRoles: (roles: Role[]) => set({roles}),
}));

export function useStoredRoles() {
  return useRolesStore((state) => state.roles);
}

export function useSetRoles() {
  return useRolesStore((state) => state.setRoles);
}
